var CallStatus = {
     Unknown             : 'Unknown'
    ,NotSpecified        : 'NotSpecified'
    ,Planning            : 'Planning'
    ,Active              : 'Active'
    ,OnHold              : 'OnHold'
    ,Cancelled           : 'Cancelled'
    ,Processing          : 'Processing'
    ,PendingVerification : 'PendingVerification'
    ,FailedVerification  : 'FailedVerification'
    ,Complete            : 'Complete'
    ,Processed           : 'Processed'
    ,Initialized         : 'Initialized'
    ,InProgress          : 'InProgress'
}

module.exports = CallStatus;